import React from 'react';
import { Navigate } from 'react-router-dom';
import { signInWithRedirect } from 'aws-amplify/auth';
import Box from '@cloudscape-design/components/box';
import Button from '@cloudscape-design/components/button';
import Container from '@cloudscape-design/components/container';
import Header from '@cloudscape-design/components/header';
import SpaceBetween from '@cloudscape-design/components/space-between';
import Spinner from '@cloudscape-design/components/spinner';
import { useAuth } from '../components/AuthProvider';

const LoginPage: React.FC = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <Box textAlign="center" padding="xxxl">
        <Spinner size="large" />
      </Box>
    );
  }
  if (user) return <Navigate to="/" replace />;

  return (
    <Box padding="xxxl" textAlign="center">
      <Box display="inline-block" margin={{ top: 'xxxl' }}>
        <SpaceBetween size="l" alignItems="center">
          <img src="/Flyin-Spotter-Logo.svg" alt="Fly-in Spotter" width={88} height={88} />
          <Container header={<Header variant="h1">Fly-in Spotter Admin</Header>}>
            <SpaceBetween size="l">
              <Box variant="p" color="text-body-secondary">
                Sign in with your Google account to manage users, content, and the aircraft registry.
              </Box>
              <Button
                variant="primary"
                iconName="user-profile"
                onClick={() => void signInWithRedirect({ provider: 'Google' })}
              >
                Continue with Google
              </Button>
            </SpaceBetween>
          </Container>
        </SpaceBetween>
      </Box>
    </Box>
  );
};

export default LoginPage;
